import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type PreAccountingState = CommonTableState;

const initialState: PreAccountingState = {
    tableState: {
        resetIndicator: 0,
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            created: false,
            modified: false,
            externalId: false
        },
        density: "compact",
        columnOrder: ["accountant.id", "code", "note", "useAsDefault", "valid", "forAll", "clientId", "externalId", "created", "modified", "mrt-row-actions"],
    },
};

export const preAccountingSlice = createSlice({
    name: "preAccounting",
    initialState: initialState,
    reducers: {
        updatePreAccountingTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updatePreAccountingTableState} = preAccountingSlice.actions;

export default preAccountingSlice.reducer;
